export const LAYER_MAX_ITEMS = 10000;
